const NAME = "ANNEXES_PAGE";

export default NAME;
